module.exports = __webpack_public_path__ + "img/HeatingCircuitOptimization.66580f9f.png";